import { differenceInDays } from 'date-fns';
export const dateView = (date: string) => {
	const _date = new Date(date);

	const time_confirm = new Date().getTime() - _date.getTime();

	// 작성한 지 24시간이 지났을 때
	if (time_confirm >= 86400000) {
		const date_d = differenceInDays(new Date(), _date);

		if (date_d < 31) return `${date_d}일 전`;
		else if (date_d >= 31 && date_d < 365) return `${Math.floor(date_d / 30)}달 전`;
		else if (date_d > 365) return `${Math.floor(date_d / 365)}년 전`;
	} else {
		// 작성한 지 1분 내일 때
		if (time_confirm < 60000) {
			return '방금 전';
			// 작성한 지 1시간 내일 때
		} else if (time_confirm >= 60000 && time_confirm < 3600000) {
			const time = time_confirm / (1000 * 60);

			return `${Math.floor(time)}분 전`;
		} else if (time_confirm >= 3600000 && time_confirm < 86400000) {
			const time = time_confirm / (1000 * 60 * 60);

			return `${Math.floor(time)}시간 전`;
		}
	}
};
